import { useRouter } from 'vue-router';

import { logout as logoutApi } from '#/api/auth';
import { useAuthStore } from '#/stores/auth';

/**
 * 로그아웃 액션 SSoT — 헤더/셸 등 로그아웃 진입점이 공유하는 단일 흐름.
 *
 * 서버 세션(HttpOnly IPSI_SESSION 쿠키)을 백엔드에서 먼저 종료한 뒤 로컬 상태를 정리한다.
 * 서버 호출이 실패해도(이미 만료 등) 로컬 정리·이동은 `finally` 로 보장한다. 에러 토스트는
 * http.ts 인터셉터가 1회 처리하므로 여기서는 흐름 제어만 한다.
 *
 * 로컬 상태 정리(장바구니·캐시 포함)는 `auth.logout()` 단일 지점이 담당한다 — 401 인터셉터 경로와
 * 동일하게 정리되도록 SSoT 화(여기서 cart.clear() 를 따로 호출하지 않는다).
 *
 * 커머스 헤더와 워크스페이스 셸이 각자 로그아웃을 재구현하지 않도록 이 컴포저블로 수렴한다
 * (두 곳 재구현 금지 — CLAUDE.md SSoT 원칙).
 */
export function useLogout() {
  const auth = useAuthStore();
  const router = useRouter();

  /**
   * 로그아웃 실행 후 지정 경로로 이동한다.
   * @param redirectTo 로그아웃 후 이동할 앱 내부 경로. 기본값은 워크스페이스 홈('/').
   * @param onDone 이동 전 부가 정리(예: 모바일 패널 닫기). 없으면 생략.
   */
  async function logout(redirectTo = '/', onDone?: () => void): Promise<void> {
    try {
      await logoutApi();
    } finally {
      auth.logout();
      onDone?.();
      await router.push(redirectTo);
    }
  }

  return { logout };
}
